import { applyMiddleware, createStore } from 'redux'
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension'
import createSagaMiddleware from 'redux-saga'

import rootReducer from './rootReducer'
import * as rootActions from './rootActions'
import rootSaga from './rootSaga'
import AppMonitoring from 'utilities/monitoring'

const sagaMiddleware = createSagaMiddleware({
  onError: AppMonitoring.noticeError,
})

const store = createStore(
  rootReducer,
// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type '{ auth: { expiry: string | null | undefined; sessionRefresh: { refreshAtMs: number | null; scheduledAtMs: number | null; }; user: { id: string; firstName: string; lastName: string; email: string; tags?: { ...; }[] | undefined; status?: ReportUserReviewStatus | un...'.
  {},
  composeWithDevToolsDevelopmentOnly(applyMiddleware(
    sagaMiddleware
  ))
)

sagaMiddleware.run(rootSaga)

store.dispatch(rootActions.appInitialization())

export default store
